<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yHD1vn/tc-custom/9780061981449.jpg?1707450481936" alt="This image is the cover for the book No Good Deed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Good Deed
      </h1>
      <p class="bookDescription body article font2">
        <p>Accomplished physician and researcher Dr. Lewis Cohen writes the untold story of two Massachusetts nurses, their struggles with end of life care, and how they were accused of murdering a patient. Captivating and powerful, <i>No Good Deed</i> explores what happens when decisions about end of life issues and the purpose of modern medicine move from the hospital to the courtroom to the church.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lewis M. Cohen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e295fd1e